<template>
  <div class="privacy" v-if="isDisplayPrivacy">
    {{prefix}}<span>{{$t('system_user_modules_privacypolicy_jibiaoshitongyiwomende')}}</span><b style="color: #12a3ff;" @click="privacy">《<span>{{$t('system_user_modules_privacypolicy_fuwuxieyiheyinsizhengce')}}</span>》</b>
  </div>
</template>
<style scoped>
  .privacy {
    margin: 0;
    bottom: 10px;
    width: 100%;
    height: 20px;
    font-size: .14rem;
    text-align: center;
    color: #555;
  }

</style>
<script>
  export default {
    data() {
      return {}
    },
    computed: {
      isDisplayPrivacy() {
        return navigator.userAgent.indexOf("weixin") == -1 && (location.href.indexOf("app.lchtrip.com") > 0 || location
          .href.indexOf("lcsl.ecsweb.net") > 0);
      }
    },
    props:['prefix'],
    methods: {
      privacy() {
        let __self = this;
        __self.$router.push({
          path: '/system/privacyPolicy',
        })
      }
    }
  }

</script>
